import { FC } from "react";
import { IconPropsType } from ".";

export const Percentage: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 3L3 13"
        stroke="#555555"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <circle cx="4" cy="4" r="1" fill="#555555" />
      <circle cx="12" cy="12" r="1" fill="#555555" />
    </svg>
  );
};
